import React, {Component} from "react";
import {InputGroup, Button, FormControl} from 'react-bootstrap';
import {XIcon} from '@primer/octicons-react';
import './SearchSpecies.css';

let _timeoutID;

const textes = {
    'choix': {
        'fr': 'Sélectionner une espèce',
        'de': 'Eine Art suchen',
        'it': 'Ricercare una specie',
        'en': 'Search a species'
    },
    'der': {
        'fr': 'Dernières sélections',
        'de': 'Letzte Selection',
        'it': '',
        'en': 'Former searches'
    }
};


class SearchSpecies extends Component {

    constructor(props) {
        super(props);

        let favs = [];
        localStorage.getItem('if.carto.favs') === null ? favs = [] : favs = JSON.parse(localStorage.getItem('if.carto.favs'));

        this.state = {
            class: 'SearchSpecies-no-around',
            input: '',
            isManagingFocus: false,
            data: [],
            error: null,
            isLoading: false,
            favs: favs,
            locale: props.locale
        };

        this.nameInput = React.createRef();

        this.handleChange = this.handleChange.bind(this);
        this.focusInput = this.focusInput.bind(this);
        this.blurInput = this.blurInput.bind(this);
        this.changeNuesp = this.changeNuesp.bind(this);
        this.resetInput = this.resetInput.bind(this);
    }

    handleChange(e) {
        if (e.target.value === '') {
            this.setState({
                class: "SearchSpecies-around",
                input: ''
            });
        } else {
            this.setState({
                class: "SearchSpecies-around-search",
                input: e.target.value,
                data: []
            });
            if (e.target.value.length > 2) {
                fetch('https://lepus.infofauna.ch/carto-old/livesearch-json.php?q=' + e.target.value + '&lang=' + this.state.locale)
                    .then(response => response.json())
                    .then(data =>
                        this.setState({
                            data: data,
                            isLoading: false
                        })
                    )
                    .catch(error => this.setState({error, data: [], isLoading: false}));
            }
        }

    }

    resetInput(e) {
        this.setState({
            input: ''
        });
        this.nameInput.focus();
        if (!this.state.isManagingFocus) {
            this.setState({
                class: "SearchSpecies-around",
                isManagingFocus: true
            })
        }
    }

    focusInput(e) {
        clearTimeout(_timeoutID);
        if (!this.state.isManagingFocus) {
            if (e.target.value === '') {
                this.setState({
                    class: "SearchSpecies-around",
                    isManagingFocus: true
                })
            } else {
                this.setState({
                    class: "SearchSpecies-around-search",
                    isManagingFocus: true
                })
            }
        }
    }

    blurInput(e) {
        _timeoutID = setTimeout(() => {
            if (this.state.isManagingFocus) {
                this.setState({
                    isManagingFocus: false,
                    class: "SearchSpecies-no-around"
                });
            }
        }, 0);

        // Prevent immediate onBlur event in Safari
        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1
            && /Macintosh/.test(navigator.userAgent) && !/iPhone|iPad|iPod/.test(navigator.userAgent)) {
            this.focusInput(e)
        }
    }

    changeNuesp(species) {
        let nf = this.state.favs;
        if (nf.indexOf(species) === -1) {
            nf.unshift(species);
        }
        nf = nf.slice(0, 3);
        if (this.state.isManagingFocus) {
            this.setState({
                class: "SearchSpecies-no-around",
                isManagingFocus: false,
                favs: nf
            })
        }
        if (species.nuesp === species.synon) {
            this.props.callbackFromParent(species.nuesp);
        } else {
            this.props.callbackFromParent(species.synon);
        }
        localStorage.setItem('if.carto.favs', JSON.stringify(nf));
    };

    shouldComponentUpdate(nextProps, prevState) {
        if (prevState.locale !== nextProps.locale) {
            this.setState({
                locale: nextProps.locale
            });
        }

        return true;
    }

    render() {
        return (
            <div className="App-header-item end" onBlur={this.blurInput} onFocus={this.focusInput}>
                <InputGroup className={this.state.class}>
                    <FormControl onChange={this.handleChange} value={this.state.input}
                                 ref={input => {
                                     this.nameInput = input
                                 }} autoComplete="off" autoCorrect="off" autoCapitalize="off"
                                 spellCheck="false"/>&nbsp;&nbsp;
                    <button className="button-link form-control-clear" onClick={this.resetInput}>
                        <XIcon size="small"/>
                    </button>
                    <Button className="btn btn-dark btn-search">
                        {textes.choix[this.state.locale]}
                    </Button>
                    <p className="species-list" hidden={this.state.class !== 'SearchSpecies-around'}>
                        {
                            this.state.favs.map((data, i) => {
                                const {nc, nuesp, synon} = data;
                                return (
                                    <a key={i} className="button-link"
                                       href={nuesp === synon ? nuesp : synon}>{nc} {nuesp !== synon ? '[syn.]' : null} <span
                                        className="vernaculaire">{data[this.state.locale]}</span></a>
                                );
                            })
                        }
                    </p>
                    <p className="species-search-results" hidden={this.state.class !== 'SearchSpecies-around-search'}>
                        {
                            this.state.data.map((data, i) => {
                                const {nc, nuesp, synon} = data;
                                return (
                                    <a key={i} className="button-link"
                                       href={nuesp === synon ? nuesp : synon}>{nc} {nuesp !== synon ? '[syn.]' : null} <span
                                        className="vernaculaire">{data[this.state.locale]}</span></a>
                                );
                            })
                        }
                    </p>
                </InputGroup>
            </div>
        )
    }
}

export default SearchSpecies;
